<div class="tout">

  <div class="logo">
    <img class="cc" src="assets/images/betsy.png" alt="">
    <div class="ttx">
      ClearCare
    </div>
  </div>

  <sel-patient *ngIf="!my_play._id && (!call_id || caller.email)" class="abs_center new_user"></sel-patient>


  <div *ngIf="call_id && !caller.email" class="title cct mt200 blue" (click)="askCallerEmail()">
    Please clike here to ask the caller to enter his or her email before selecting or adding a patient
  </div>

  <div class="cct " *ngIf="my_play._id">
    <div class="title">
      Patient: {{my_play.first_name}} {{my_play.last_name}} <img src="assets/images/edit.svg" class="edit_p" alt="" (click)="editPatient()">
    </div>
    <!-- <div class="btn" (click)="addPatient()">
      <div class="abs_center">
        Add Patient
      </div>
    </div> -->

    <div class="title">
      <span class="blue" (click)="selOtherPatient()">Change patient</span>
    </div>

    <div class="add_user">
      Users
      <img class="add_user_l" src="assets/images/list.svg" alt="" (click)="listUser()">
      <img class="add_user_l" src="assets/images/new_user.svg" alt="" (click)="addUser()">
    </div>

    <div class="btn" (click)="bShowSelTask=true">
      <div class="abs_center">
        Select Task
      </div>
    </div>

  </div>
  <div class="abs_center btn add_patient" (click)="edit_patient={}">
    <div class="abs_center">
      Add Patient
    </div>
  </div>
  <div class="boxes">

    <care *ngIf="task_index >=0 && !bAddingUser" class="care"></care>

  </div>
  <div class="videos" *ngIf="call_id && !(task_index >=0 && !bAddingUser)">

    <k-video role="caller" [no_prompts]="true" [show_canvas]="false" screen="in-call-asset" [small]="true" class="video video_l">
    </k-video>

    <k-video role="rep" [no_prompts]="true" [show_canvas]="false" screen="in-call-asset" [small]="true" class="video" [bMirrow]="true">
    </k-video>

  </div>
  <patient class="abs_center new_user" *ngIf="edit_patient" (close)="closePatient()" [patient]="edit_patient"></patient>
  <train-new-user *ngIf="bAddingUser" (close)="bAddingUser=false" class="abs_center new_user" [user_id]="edit_user_id" [users]="users" [caller]="caller"></train-new-user>
  <app-sel-task *ngIf="bShowSelTask" class="abs_center new_user" (close)="closeSelTask()"></app-sel-task>
  <app-sel-user *ngIf="bSelUser" class="abs_center new_user" [users]="users" (close)="closeSelUser()" (sel_user)="loadUser($event)"></app-sel-user>

</div>
